import { useSelector } from 'react-redux'
import { UseI18n } from '../../../../common/hooks/useI18n'
import { Element } from '../../../../common/html/element'
import { Loading } from '../../../../common/loading'
import { Notification } from '../../../../common/notification'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Table } from '../../../../common/table'
import { COMPANY_TYPES, EMPTY_VALUE } from '../../../../utils/common'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import {
  selectIndustryYear,
  selectLoading,
  selectTopIndustryPlayers,
  selectTopIndustryPlayersById,
} from '../../store/slice'
import { CompanyName } from './CompanyName'
import { CompanyRevenue } from './CompanyRevenue'
import { COLUMN_IDS } from './helper'
import classes from './index.module.scss'

export const TopIndustryPlayers = () => {
  const { formatCurrency } = useFormatCurrency(SCREEN.SUMMARY)
  const { companyType } = useSelector(selectCompanyInfo)
  const industryYear = useSelector(selectIndustryYear)
  const data = useSelector(selectTopIndustryPlayers())
  const isLoading = useSelector(selectLoading('topIndustryPlayers'))

  const revenueText = UseI18n(
    `companySummary.topIndustryPlayers.${
      companyType === COMPANY_TYPES.CORPORATE
        ? 'NET_REVENUE_IN'
        : companyType === COMPANY_TYPES.SECURITIES
        ? 'OPERATING_INCOME_IN'
        : [
            COMPANY_TYPES.LIFE_INSURANCE,
            COMPANY_TYPES.NON_LIFE_INSURANCE,
          ].includes(companyType)
        ? 'REVENUE_INSURANCE_IN'
        : 'TOTAL_ASSETS_IN'
    }`,
  )

  const schema = Object.keys(COLUMN_IDS).map((key) => {
    const colId = COLUMN_IDS[key]
    const title =
      colId === COLUMN_IDS.REVENUE
        ? revenueText + ' ' + (industryYear || EMPTY_VALUE)
        : 'companySummary.topIndustryPlayers.' + key

    return {
      colId,
      title,
      isI18n: colId === COLUMN_IDS.REVENUE ? false : true,
      thStyle: {
        justifyContent: colId === COLUMN_IDS.REVENUE ? 'flex-end' : '',
      },
      tdStyle: {
        textAlign: colId === COLUMN_IDS.REVENUE ? 'right' : 'left',
        whiteSpace: colId === COLUMN_IDS.COMPANY_NAME ? '' : 'nowrap',
        width: colId === COLUMN_IDS.COMPANY_NAME ? '70%' : 'unset',
      },
      render: (data, { rowId }) => {
        switch (colId) {
          case COLUMN_IDS.COMPANY_NAME:
            return <CompanyName rowId={rowId} />
          case COLUMN_IDS.REVENUE:
            return formatCurrency({
              value: data,
              year: industryYear,
              exchangeRateType:
                companyType === COMPANY_TYPES.BANK
                  ? 'lastDayRate'
                  : 'averageRate',
            })
          default:
            return data
        }
      },
    }
  })

  return (
    <Element className={classes.container}>
      {isLoading ? (
        <Loading />
      ) : !data || !data.length ? (
        <Notification />
      ) : (
        <Element className="flexColumn h100">
          <CompanyRevenue />
          <Element className="flex1 minH0">
            <Table
              ids={data.map((i) => i.rank)}
              getDataFromRedux={selectTopIndustryPlayersById}
              isLoading={isLoading}
              schema={schema}
            />
          </Element>
        </Element>
      )}
    </Element>
  )
}
